/**
 * CPF de quem paga o PIX.
 *
 * A Redfox recusa cobrança sem o documento do pagador. Validar aqui pelos
 * dígitos verificadores evita que o cliente descubra o erro só quando a
 * cobrança é recusada, com o horário já marcado.
 */

export function normalizeCpf(value: string): string {
  return String(value ?? '').replace(/\D/g, '');
}

export function isValidCpf(value: string): boolean {
  const cpf = normalizeCpf(value);
  if (cpf.length !== 11) return false;
  // 000.000.000-00, 111.111.111-11…: passam na conta e não existem.
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const digito = (tamanho: number) => {
    let soma = 0;
    for (let i = 0; i < tamanho; i++) soma += Number(cpf[i]) * (tamanho + 1 - i);
    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };

  return digito(9) === Number(cpf[9]) && digito(10) === Number(cpf[10]);
}

/** O que as telas mostram: só os quatro últimos dígitos. */
export function maskCpf(digits: string): string {
  const cpf = normalizeCpf(digits);
  return `***.***.*${cpf.slice(7, 9)}-${cpf.slice(9, 11)}`;
}

/** CNPJ pelos dígitos verificadores (o documento de uma barbearia PJ). */
export function isValidCnpj(value: string): boolean {
  const cnpj = normalizeCpf(value);
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  const digito = (tamanho: number) => {
    const pesos =
      tamanho === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const soma = pesos.reduce((t, p, i) => t + Number(cnpj[i]) * p, 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  return digito(12) === Number(cnpj[12]) && digito(13) === Number(cnpj[13]);
}
